import FillErrorAlert from "components/Alerts/FillErrorAlert";
import CompTextField from "components/CompTextField"
import { useApi } from "hooks/useApis"
import { useEffect, useState } from "react"
import { CircularProgress, InputAdornment } from "@mui/material";
import LoopIcon from '@mui/icons-material/Loop';
import * as palette from "../../styles/variables";
import { Tooltip } from "@mui/material";
export const NisField = ({
  isView,
  apiText,
  isEdit,
  textLabel,
  name,
  register,
  unregister,
  errors,
  helperText,
  setValue,
  nis = "",
  handleNis = () => { },
  benefitNis,
  flexGrow = "1",
  b_status = '',
  isBirthInfoForm=false
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalidNis, setIsInvalidNis] = useState(false);
  const [isNotRegisteredNis, setIsNotRegisteredNis] = useState(false);
  const [updateNis, setUpdateNis] = useState(false);

  const api = useApi();

  const getNisData = async () => {
    try {
      setIsLoading(true);
      const response = await api.getNisInfo(nis);
      if (response.status === 200 && response.data.results[0])
        return response.data.results[0];
      
      if (response.status === 400) {
        setIsInvalidNis(true);
      } else if (response.status === 404) {
        setIsNotRegisteredNis(true);
      }

      setValue(name, "");
      return false;
    } catch (err) {
    } finally { // it works like a defer
      setIsLoading(false);
    }
  }

  const updateNisData = async () => {
    try {
      setIsLoading(true);
      const response = await api.getListPersonByNis(nis);
      setUpdateNis(false)
      return response.results[0]
    } catch (err) {
    } finally { // it works like a defer
      setIsLoading(false);
    }
  }

  const shouldGetData = () => {

    nis = nis?.replace(/\D/g, ''); //remove qualquer caracter q não seja numero
    
    setValue(name, nis)

    const isValidNis = () => nis && nis.length === 11;

    if (isEdit) {
      return isValidNis() && nis !== benefitNis;
    }
    if (!isView)
      return isValidNis();

    return false;
  }

  useEffect(() => {
    if (!nis)
      setValue(name, "");

    if(updateNis){
      updateNisData().then((data) => {
        if (data)
          handleNis(data);
          setValue(name, data.nis || data.child_nis || data.pregnant_nis || data.twin_child_nis || '');
      });
    }

    if (shouldGetData()) {
      getNisData().then((data) => {
        if (data)
          handleNis(data);
          setValue(name, data.nis || data.child_nis || data.pregnant_nis || data.twin_child_nis || '');
      });
    }
  }, [nis, benefitNis, updateNis]);


  

  return (
    <>
      <CompTextField
        isView={isView}
        edit={isEdit}
        apiText={apiText || ""}
        textLabel={textLabel}
        // mask={nis ? "99999999999" : null}
        placeholder="00000000000"
        required
        style={{ flexGrow }}
        name={name}
        register={register}
        unregister={unregister}
        error={errors}
        helperText={helperText}
        benefitStatus={b_status}
        InputProps={{
          endAdornment: (
            isLoading ? 
              <InputAdornment position="end">
                <CircularProgress size={20} />
              </InputAdornment>
            :
            isEdit && !isBirthInfoForm && 
            <div onClick={()=>setUpdateNis(true)}  style={{cursor: 'pointer', display: "flex", flexDirection: "column",justifyContent: 'center'}} >
              <Tooltip title='Atualizar dados' >
              <LoopIcon style={{color: palette.lightAzul}}/>
              </Tooltip>
            </div>            
          ),
        }}
      />

      <FillErrorAlert
        open={isInvalidNis}
        onClose={() => setIsInvalidNis(false)}
        message="O NIS informado já possui registro."
      />
      <FillErrorAlert
        open={isNotRegisteredNis}
        onClose={() => setIsNotRegisteredNis(false)}
        message="Pessoa sem registro no CadÚnico."
      />
    </>
  );
}
